import React, { useState, useEffect } from "react";
import { AlarmData } from "../Common/Types/types";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { useAppDispatch } from "../Core/store.hooks";
import { fetchAlarmDatas, getAlarmsLoadingSelector, getAlarmsSelector } from "./Slice";
import AlarmComboChart from "../Common/Components/Charts/ComboChart";
import FormatAlarms from "./FormatAlarms";
import {getParamsSelector, updateParams } from "../Common/Slices/ParamSlice";
import { getOptionsSelector } from "../Common/Slices/optionSlice";
import Format from "../Common/Util_methods/formatParamOptions";
import { getDevicesSelector } from "../Devices/Slice";



interface AlarmStatisticsChartWidgetProps {
    id: string;
    header: string;
    values: string;
    series: {
        name:string,
        unit:string,
        color:string
        }
}

const AlarmStatisticsChartWidget = (props: AlarmStatisticsChartWidgetProps) => {
    const [AlarmDatas, updateAlarmDatas] = useState([]);
    const [dataProcessed, setDataProcessed] = useState<boolean>(false);

    const deviceObjects = useSelector(getDevicesSelector)
    const options = useSelector(getOptionsSelector)
    const params = useSelector(getParamsSelector)
    const alarms = useSelector(getAlarmsSelector);
    const loadingState = useSelector(getAlarmsLoadingSelector);

    const dispatch = useAppDispatch();

    useEffect(()=>{
        if (loadingState === "fulfilled" && alarms.length > 0){
            updateAlarmDatas(sortData(alarms));
        }else{
            updateAlarmDatas([])
        }
        setDataProcessed(true)
    },[alarms,options.chartItemNumber])

    useEffect(()=>{
        if (loadingState==="pending"){
            setDataProcessed(false)
        }
        if(loadingState === "rejected"){
            setDataProcessed(true);
        }
        if(loadingState === "fulfilled" && alarms.length === 0){
            setDataProcessed(true);
        }
    },[loadingState])

    const handleChartClick = (id:string) =>{
        if (id != null){
            let newParams = {...params}
            newParams.alarmText = id
            dispatch(updateParams(newParams))
        }
    }
    const sortData = (data:AlarmData[]) => {
        const dataInHours = FormatAlarms.durationInHours(data);
        const sortedData = FormatAlarms.sortAlarmsBy(props.values,dataInHours,"desc");
        return sortedData;
    }

    if (!dataProcessed) return <Spinner text="data" />;
    if (AlarmDatas == null || loadingState === "rejected") {
        //proper error handling should be added with promise error response
        return (
            <ErrorMessage
                text={"Oops something went wrong, unable to get data."}
                id={props.id}
                header={props.header}
            />
        );
    }   
    if (AlarmDatas != null && AlarmDatas.length == 0) {
        return (
            <ErrorMessage
                text={"No data found for selected filters."}
                id={props.id}
                header={props.header}
            />
        );
    }
    return <AlarmComboChart 
        type="alarms" 
        clickHandler={handleChartClick} 
        id={props.id} 
        data={AlarmDatas} 
        category="text"  
        values={props.values} 
        series={props.series}
        itemNumber={options.chartItemNumber}
        />;
};
export default AlarmStatisticsChartWidget;
